<template>
  <div class="scheduleIndexUserEditFormModal">
    <bs-modal
      ref="scheduleUserEditModalRef"
      :modal-dialog-settings="['modal-fullscreen']"
    >
      <!-- header -->
      <template v-slot:header>
        <h5 class="modal-title" id="scheduleIndexUserEditFormModalLabel">
          担当者変更
        </h5>
      </template>
      <!-- ./header -->
      <!-- body -->
      <div class="mb-3">
        <label for="recipient-name" class="col-form-label">担当者</label>
        <multiselect
          data-bs-backdrop="static"
          v-model="userEditForm.users"
          mode="tags"
          placeholder="Select your characters"
          :options="usersForMultiPulldownByVue.users[0]"
          :searchable="true"
          :groups="true"
        />
      </div>
      <!-- ./body -->
      <!-- footer -->
      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-secondary"
          @click="hideScheduleUserEditModal()"
        >
          キャンセル
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="updateScheduleUser()"
        >
          登録
        </button>
      </template>
      <!-- ./footer -->
    </bs-modal>
  </div>

  <form id="scheduleUserForm" method="POST">
    <input type="hidden" id="schedule_id" name="schedule_id" />
    <input type="hidden" id="schedule_users" name="schedule_users" />
  </form>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { BsModal } from "bs-modal-vue";
import {
  usersForMultiPulldownByVue,
  userEditForm,
} from "../../compositions/variables";
import Multiselect from "@vueform/multiselect";
import {
  scheduleUserEditModalRef,
  hideScheduleUserEditModal,
} from "../../compositions/scheduleUser/scheduleUserEditForm";
import { updateScheduleUser } from "../../compositions/axios/user/scheduleUserAxios";

export default defineComponent({
  components: {
    BsModal,
    Multiselect,
  },
  props: {
    model: {
      type: Object,
      required: false,
      default() {
        return [];
      },
    },
  },
  setup(props: { model: any }) {
    scheduleUserEditModalRef.value = ref<any>(null);
    onMounted(() => {});
    return {
      /* components */
      BsModal,
      /* function */
      hideScheduleUserEditModal,
      updateScheduleUser,
      /* variables */
      userEditForm,
      scheduleUserEditModalRef,
      usersForMultiPulldownByVue,
    };
  },
});
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
